import { state as stateApp } from '../app.logic'
import moment from 'moment'
require('moment-precise-range-plugin');

export const dateFormat = ({ text, format }) => {
    if (!text) {
        return null;
    }
    let result = moment(text);
    if (stateApp.locale === "th") {
        result = result.add(543, "years");
    }
    return result.format(format);
}

export const dateDiffStr = ({ record }) => {
    const expireDate = moment(record.expireDate).add(1, "day");
    const effectiveDate = moment(record.effectiveDate);

    const preciseDiff = moment.preciseDiff(expireDate, effectiveDate, true);
    const years = preciseDiff.years;
    let months = preciseDiff.months;
    let days = preciseDiff.days;
    if (years === 0 && months === 1 && days > 0) {
        months = 0;
        const diffDuration = moment.duration(expireDate.diff(effectiveDate));
        days = diffDuration.asDays();
    }
    return [years > 0 ? `${years} ปี`: null, months > 0 ? `${months} เดือน`: null, days > 0 ? `${days} วัน`: null].filter(d => d != null).join(" ");
}